import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { sortBy}  from 'lodash'
import moment from 'moment'

export default function Question({event, props}) {

  const tagOwner = useSelector(state => state.tagOwner)
  const equestions = useSelector(state => state.eventQuestions.filter((eq) => eq.event_id == event.id && eq.visible && !eq.archived))
  const questions = sortBy(equestions, (question) => moment(question.created_at))
  //console.log(eventQuestions.filter(question => question.visible))
  // const questions = [
  //   {body: "When does the session start?", tag_owner: { name: "Max Mustermann", company: "Mustercompany"}}
  // ]
  const lastMessage = questions[questions.length - 1]?.created_at
  const objDiv = document.getElementById("questions");

  useEffect(() => {
    if(objDiv)
      objDiv.scrollTop = objDiv.scrollHeight;
  }, [lastMessage, objDiv])

  let lastName = null
  return (
    <>
      {questions == null || questions.length == 0 ? (
        <></>
      ) : (
        <div id="questions" className="mt-2 p-2" style={{maxHeight: "270px", overflowY: "auto", overflowX: "hidden", backgroundColor: "white"}}>
          {questions.map((question, index) => {
            let content = (
              <div className="row" key={"quest-" + question.title + index}>
                <div className="col">

                  {lastName == null || lastName != question.tag_owner.name &&
                  <small className={classNames("text-muted", "question-author")} style={{paddingRight: "5px"}}>
                    {question.tag_owner.name}
                    {false && question.tag_owner.company && question.tag_owner.company != "" &&
                    <span className="text-muted">, {question.tag_owner.company}</span>
                    }
                  </small>
                  }
                  <div className="question ml-1">{question.body}</div>
                </div>
              </div>
            )
            lastName = question.tag_owner.name
            return content
          })}
        </div>
        
      )}
    </>
  )
}
